import React, { useEffect, useState } from 'react';
import styles from './index.module.scss';
import { fuelHelper } from 'helpers/fuel-helper';
import { countDownFormatHelper } from 'helpers/time-helper';
import Button from 'components/button';
import { useInterval } from 'helpers/time-helper';
import { useRefuelingRequest } from './use-refueling-request';
import amplitude from 'service/amplitude';
import classnames from 'classnames/bind';
import iconClose from 'assets/icon_xx.svg';
import { ReactComponent as IconInfo } from 'assets/info-outlined.svg';
import { useAppContext } from 'use-app';
const cx = classnames.bind(styles);

const RefuelingRequest = ({ refuelingRequest }) => {
  const { state: appState } = useAppContext();
  const { isUsingLegacyReceiptWording } = appState.bootstraps;
  const { rejectRefuelingRequest, acceptRefuelingRequest, refuelingRequestTimeout } = useRefuelingRequest();
  const { id, expiresIn, gasStationName, requestAmount, discountAmount, amount, quantity, sku, orderReceiptInfo } =
    refuelingRequest;
  const isShow = refuelingRequest ? true : false;
  const [countDownTime, setCountDownTime] = useState(expiresIn);

  useEffect(() => {
    amplitude.refueling_request_pageview();
  }, []);

  useInterval(() => {
    if (countDownTime === 0) {
      refuelingRequestTimeout();
    } else {
      setCountDownTime(prev => prev - 1);
    }
  }, 1000);

  const ReceiptRemind = () => {
    if (isUsingLegacyReceiptWording || !orderReceiptInfo.issuerType || orderReceiptInfo.issuerType === '') return <></>;

    const text = () => {
      switch (orderReceiptInfo.issuerType) {
        case 'autopass':
          return '發票自動存入設定載具';
        case 'partner':
          return '現場開立發票，交易後請記得索取';
        default:
          return '';
      }
    };

    return (
      <>
        <hr />
        <div className={styles.remind}>
          <IconInfo />
          {text()}
        </div>
      </>
    );
  };

  const layoutClass = cx({
    layout: true,
    show: isShow,
  });

  return (
    <div className={layoutClass}>
      <div className={styles.refuelingRequest}>
        <img
          className={styles.close}
          src={iconClose}
          onClick={() => {
            amplitude.cancel_refueling_request();
            rejectRefuelingRequest(id);
          }}
          alt="close"
        />
        <div className={styles.title}>是否同意授權{gasStationName}使用麻吉付扣款？</div>
        <div className={styles.content}>
          <div className={styles.refuelingList}>
            <div className={styles['name']}>品名</div>
            <div className={styles['name-info']}>{fuelHelper(sku)}</div>
            <div className={styles['count']}>數量</div>
            <div className={styles['count-info']}>{`${Number(quantity)}公升`}</div>
            <div className={styles['total']}>小計</div>
            <div className={styles['total-info']}>{`$${Number(amount)}`}</div>
            <div className={styles['discount']}>折扣</div>
            <div className={styles['discount-info']}>{`-$${Math.abs(Number(discountAmount))}`}</div>
            <div className={styles['payment']}>付款金額</div>
            <div className={styles['payment-info']}>{`$${Number(requestAmount)}`}</div>
          </div>

          <ReceiptRemind />
        </div>
        <Button
          theme="yellow"
          block={true}
          onClick={() => {
            amplitude.accept_refueling_request();
            acceptRefuelingRequest(id);
          }}
        >
          同意付款
        </Button>
        <div className={styles.subText}>此交易授權邀請將在 {countDownFormatHelper(countDownTime)} 後失效</div>
      </div>
    </div>
  );
};

const RefuelingRequestDialog = ({ refuelingRequest }) => {
  if (!refuelingRequest) return <></>;
  return <RefuelingRequest refuelingRequest={refuelingRequest} />;
};

export default RefuelingRequestDialog;
